module.exports = __webpack_public_path__ + "static/banner-b-eb13730bacf6bb80caefec87f7d26df6.png";